'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactI18next = require('react-i18next');

var _user = require('../../helpers/user');

var _FormInput = require('../FormInput');

var _EnterAddressFormStyle = require('./EnterAddressFormStyle.scss');

var _EnterAddressFormStyle2 = _interopRequireDefault(_EnterAddressFormStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailField = function EmailField(_ref) {
  var t = _ref.t,
      order = _ref.order,
      user = _ref.user,
      _ref$errors = _ref.errors,
      errors = _ref$errors === undefined ? {} : _ref$errors;

  if (order.user_id) return '';

  return _react2.default.createElement(
    'fieldset',
    { styleName: 'm-fieldset' },
    _react2.default.createElement(
      _FormInput.Legend,
      null,
      t('spree.email_address')
    ),
    _react2.default.createElement(
      _FormInput.Field,
      {
        inputName: 'email',
        errors: errors
      },
      _react2.default.createElement(
        _FormInput.Label,
        { htmlFor: 'email' },
        t('spree.email')
      ),
      _react2.default.createElement(_FormInput.Input, {
        id: 'email',
        name: 'order[email]',
        type: 'email',
        defaultValue: (0, _user.orderEmail)(order, user),
        required: true
      })
    )
  );
};

exports.default = (0, _reactI18next.translate)()((0, _reactCssModules2.default)(_EnterAddressFormStyle2.default, { allowMultiple: true })(EmailField));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/AddressForm/EmailField.js
// module id = 2264
// module chunks = 0